export default "__VITE_ASSET__WE0A3N9S__"